import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { isPublishedBookFeature } from '@services/firebase'
import type { DashboardBook } from '@services/firebase/normalizers'
import type { LearningLesson } from '@services/firebase/learning'
import { getAudiobookLessons } from './learning-helpers'
import { getOnlineBookAvailabilityQueryOptions } from './online-book-availability-query'

interface LearningFeatureVisibilityInput {
  readonly book: DashboardBook | null | undefined
  readonly isLessonsLoading?: boolean
  readonly lessons: readonly LearningLesson[]
}

export function useLearningFeatureVisibility({
  book,
  isLessonsLoading = false,
  lessons,
}: LearningFeatureVisibilityInput) {
  const hasOnlineBook = isPublishedBookFeature(book?.enableOnlineBook)
  const hasOnlineAudio = isPublishedBookFeature(book?.enableAudioBook)
  const audioLessonCount = useMemo(
    () => getAudiobookLessons([...lessons]).length,
    [lessons],
  )
  const onlineBookAvailabilityQuery = useQuery({
    ...getOnlineBookAvailabilityQueryOptions(book?.id ?? ''),
    enabled: Boolean(book?.id),
  })
  const onlineBookAvailability = onlineBookAvailabilityQuery.data

  return {
    audioLessonCount,
    hasOnlineAudio,
    hasOnlineBook,
    isLessonsLoading,
    // true | false | undefined — undefined while the probe is unresolved
    onlineBookAvailability,
  }
}
